import type { ReactNode } from 'react';
import { useState } from 'react';

export interface ToggleDrawerProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const ToggleDrawer = ({
  open: openInitial = false,
  children,
}: {
  open?: boolean;
  children: (_: ToggleDrawerProps) => ReactNode;
}) => {
  const [open, setOpen] = useState(openInitial);
  return children({ open, setOpen });
};
